import * as React from 'react';
import app from 'srcJs/App';
import { useEffect, useState } from 'react';
import {
  isNotifierTempSuppressed, tempSuppressNotifier,
} from 'moduleBase/components/header/confirm-email-notifier/constants/helpers';
import { SentAlert } from 'moduleBase/components/header/confirm-email-notifier/components/SentAlert';
import { NotifyAlert } from 'moduleBase/components/header/confirm-email-notifier/components/NotifyAlert';
import { TIMEOUT_TO_FADE_AFTER_SEND } from 'moduleBase/components/header/confirm-email-notifier/constants';
import { ThunkDispatch } from 'redux-thunk';
import { State } from 'moduleBase/types/State';
import { AnyAction } from 'redux';
import { useDispatch } from 'react-redux';
import { resendConfirmationEmailAction } from 'moduleBase/components/header/confirm-email-notifier/actions/send-email';

export const ConfirmEmailNotifier = () => {
  const [show, setShow] = useState(false);
  const [sent, setSent] = useState(false);

  const user = app.getUser();

  useEffect(() => {
    if (!user.isEmailConfirmed() && !isNotifierTempSuppressed()) {
      setShow(true);
    }
  }, []);

  const onClose = (): void => {
    tempSuppressNotifier();
    setShow(false);
  };

  const dispatch: ThunkDispatch<State, any, AnyAction> = useDispatch();

  const resendConfirmation = () => {
    dispatch(resendConfirmationEmailAction()).then(() => {
      setSent(true);
      tempSuppressNotifier();
      setTimeout(() => setShow(false), TIMEOUT_TO_FADE_AFTER_SEND);
    });
  };

  if (!show) {
    return null;
  }

  if (sent) {
    return (<SentAlert onClose={onClose} />);
  }

  return (<NotifyAlert onClose={onClose} onClick={resendConfirmation} />);
};
